import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Category from "./Category";
import Airconchecklist from "./Airconchecklist";
import Airconservicing from "./Airconservicing";

const Setup = () => {
  let [searchParams, setSearchParams] = useSearchParams();
  let navigate = useNavigate();

  const [selected, setSelected] = useState(
    searchParams.get("selected") != null
      ? searchParams.get("selected")
      : "category"
  );
  const [selectedarr, setSelectedarr] = useState([
    { label: "Category", value: "category" },
    { label: "Checklist", value: "checklist" },
    { label: "Servicing", value: "servicing" },
  ]);

  useEffect(() => {
    /*  setSelected(searchParams.get("selected")); */
  });
  const selectedfn = (value) => {
    setSelected(value);
    navigate("/setup?selected=" + value);
  };
  return (
    <div className="container">
      <div className="d-flex  ">
        <h1 className="flex-fill">Settings</h1>{/* <div><button
            onClick={() => {
              navigate("/userevent");
            }}
            type="submit"
            className="btn btn-primary"
          >
            <i className="fa fa-plus"></i> Add User
          </button></div> */}
      </div>
      {/* section tab menu */}
      <div className="d-flex flex-wrap mb-3 p-1">
        <a className="btn btn-secondary  me-3">
          <i className="fa fa-cogs"></i>
        </a>
        {selectedarr.map((selectedarrs, index) => (
          <button
            onClick={() => selectedfn(selectedarrs.value)}
            key={index}
            className={
              selected === selectedarrs.value
                ? "btn btn-primary me-2"
                : "btn btn-light me-2"
            }
          >
            {selectedarrs.label}
          </button>
        ))}
      </div>
      {/* section tab page */}
      <div>
        {selected === "category" ? (
          <Category />
        ) : selected === "checklist" ? (
          <Airconchecklist />
        ) : (
          <Airconservicing />
        )}
      </div>
    </div>
  );
};

export default Setup;
